import { MessageSquare } from 'lucide-react';
import { useState } from 'react';

const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLScBB6Isrq9crpLI7Mu8To1I458TT1WPIECs7F-5KuD9DwR5Zg/viewform';

export const FeedbackButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.open(GOOGLE_FORM_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 right-6 bg-[#21A366] hover:bg-[#1a8252] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 group z-40"
      style={{ 
        padding: isHovered ? '12px 20px 12px 12px' : '12px',
        width: isHovered ? 'auto' : '48px',
        height: '48px'
      }}
      aria-label="Send feedback"
    >
      <MessageSquare className="w-6 h-6 flex-shrink-0" strokeWidth={2} />
      <span 
        className="overflow-hidden transition-all duration-300 whitespace-nowrap font-medium text-sm"
        style={{ 
          maxWidth: isHovered ? '120px' : '0px',
          opacity: isHovered ? 1 : 0,
        }}
      >
        Send Feedback
      </span>
    </button>
  );
};
